// validationRules.ts

import { DeliverOption } from "enum/DeliveryOption";

export const getToggleTab2Validations = (
  values: any,
  pickup: any,
  deliver: any,
  deliveryPin: string | null,
  canadianPhoneRegExp: RegExp
) => [
    { condition: !pickup?.city, message: "Pick-Up Address is required" },
    { condition: !values.pickupContactName, message: "Contact Name is required" },
    { condition: !deliver?.city, message: "Deliver Address is required" },
    { condition: !values.deliverContactName, message: "Contact Name is required" },
    {
      condition: values.deliverContactPhone && !canadianPhoneRegExp.test(values.deliverContactPhone),
      message: "Invalid phone number",
    },
    { condition: !values.vehicleType, message: "Vehicle Type is required" },
    { condition: !values.totalWeight, message: "Total weight is required" },
    { condition: Number(values.totalWeight) < 1, message: "Total weight cannot be negative" },
    { condition: !values.totalItems, message: "Total Items are required" },
    { condition: Number(values.totalItems) < 1, message: "Total Items cannot be negative" },
    { condition: values.deliveryOption === "--select delivery option--", message: "Delivery Option is required" },
    {
      condition: values.deliveryOption === DeliverOption.DELIVERY_VERIFICATION_PIN && !deliveryPin,
      message: "Delivery pin is required",
    },
  ];
